module.exports = __webpack_public_path__ + "img/fevend-collection-page.43cdc89a.png";